import { render, staticRenderFns } from "./WBots.vue?vue&type=template&id=413e982e&"
import script from "./WBots.vue?vue&type=script&lang=js&"
export * from "./WBots.vue?vue&type=script&lang=js&"
import style0 from "./WBots.vue?vue&type=style&index=0&id=413e982e&prod&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports